<template>
	<div id="mapMain"></div>
</template>

<script>
	import mapJson from './map.json'
	export default {

		props: {
			mapJeoData: Object,
			mapJson: Array,
			visible: {
				type: Boolean,
				default: false
			}

		},
		data() {
			return {
				chart: null
			};
		},
		watch: {
			mapJeoData: {
				handler(newValue, oldValue) {
					console.log(this.$echarts)
					console.log(this.chart)
					if (this.chart) {
						this.chart.dispose()
						// this.$echarts.unregisterMap('FeatureCollection');
					}
					this.initMap()
				},
				deep: true,
			},
			mapJson: {
				handler(newValue, oldValue) {
					console.log(this.$echarts)
					console.log(this.chart)
					if (this.chart) {
						this.chart.dispose()
						// this.$echarts.unregisterMap('FeatureCollection');
					}
					this.initMap()
				},
				deep: true,
			},
		},
		mounted() {
			/* 
			获取当前用户的信息：
			管理员
			如果是平台。看全国 
			如果是运营中心。只看本省的
			
			银行
			如果是省级，查看省级
			如果是市区级，查看市级
			如果是区级，查看区级
			*/
			let userInfo = JSON.parse(window.localStorage.getItem('USERINFO'))

			this.$nextTick(() => {





				this.initMap()
			})

		},
		activated() {
			// 由于给echart添加了resize事件, 在组件激活时需要重新resize绘画一次, 否则出现空白bug
			if (this.chart) {
				// console.log(this.value);
				this.chart.resize();
			}
		},

		methods: {

			initMap() {
				this.chart = this.$echarts.init(document.getElementById('mapMain'))
				let mapData = []
				console.log(this.mapJson)
				this.mapJson.forEach(item => {
					if (item.latitudeLongitude) {
						if(item.latitudeLongitude){
							let latitudeLongitude = item.latitudeLongitude.split(',')
							mapData.push({
								name: item.tenantIdName,
								value: [latitudeLongitude[0], latitudeLongitude[1],'10'],
								allLoanAmount: item.allLoanAmount,
								allLoanAmountCheckY: item.allLoanAmountCheckY,
								allLoanCount: item.allLoanCount,
								inLoanAmount: item.inLoanAmount,
								inLoanAmountCheckY: item.inLoanAmountCheckY,
								inLoanCount: item.inLoanCount,
								// tooltip: {
								//                 formatter: 'Your Tooltip Content'
								//             }
								// value:[115.159556,42.626232]
							})
						}
						

					}

				})
				if(mapData.length==1){
					mapData.push({
						name: '',
						value: [-10, -10,-10],
					})
				}
				console.log(mapData)
				const _this = this
				// 基于准备好的dom，初始化echarts实例
				let cahrtOption = {
					geo3D: {
						tooltip: {
							show: true, // 显示提示框
							trigger: "item",
							backgroundColor: 'rgba(0,0,0,0.82)',
							formatter: function(params) {
								// 格式化提示框内容，这里使用标记点的信息
								console.log(params)
								return "<div class='tooltip-warp'><div class='tooltip-name'>" + params.data.name +
									"</div>" + "<div class='tooltip-item'>" + '累计贷款笔数/金额：' + params.data.allLoanCount +
									'笔/' + params.data.allLoanAmount + (params.data?.allLoanAmountCheckY == 1 ? '万' :
										params.data?.allLoanAmountCheckY == 2 ? '亿' : '') + "</div>" +
									"<div class='tooltip-item'>" + '执行中贷款笔数/金额：' + params.data.inLoanCount + '笔/' +
									params.data.inLoanAmount  + (params.data?.inLoanAmountCheckY == 1 ? '万' : params.data
										?.inLoanAmountCheckY == 2 ? '亿' : '') + "</div></div>"
						
						
						
							},
						},
						silent: true,
						type: 'map3D', // 系列类型
						name: 'map3D', // 系列名称
						map: 'FeatureCollection',
						zlevel: 10000,
						boxHeight: 4,
						zoom: 0.5,
						label: {
							// 标签的相关设置
							show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
							//distance: 50, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离
							//formatter:, // 标签内容格式器
							color: '#fff',
							textStyle: {
								// 标签的字体样式
								color: '#fff', // 地图初始化区域字体颜色
								fontSize: 18, // 字体大小
								// opacity: 1, // 字体透明度
								// backgroundColor: 'rgba(255,23,11,1)', // 字体背景色
							},
						},

						itemStyle: {
							// 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
							color: '#EFAB44', // 地图板块的颜色
							opacity: 0.2, // 图形的不透明度 [ default: 1 ]
							borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
							borderColor: '#EFAB44', // 图形描边的颜色。[ default: #333 ]
						},
						emphasis: {
							// 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
							label: {
								color: '#fff',
								// label高亮时的配置
								show: false,
								textStyle: {
									color: '#f00', // 高亮时标签颜色变为 白色
									fontSize: 25, // 高亮时标签字体 变大
								},

								padding: 5,

							},
							itemStyle: {
								color: 'rgba(37,22,10, 0.4)', // 地图板块的颜色
								opacity: 1, // 图形的不透明度 [ default: 1 ]
								borderWidth: 2, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
								borderColor: 'rgba(253,226,164, 1)', // 图形描边的颜色。[ default: #333 ]

							}
						},
						groundPlane: {
							// 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
							show: false, // 是否显示地面。[ default: false ]
						},
						// postEffect:{
						// 	enable:true,
						// 	bloom:{
						// 		enable:true,
						// 		bloomIntensity:100
						// 	}
						// },
						distance: 50,
						light: {
							// 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
							main: {
								// 场景主光源的设置，在 globe 组件中就是太阳光。
								color: '#fff', //主光源的颜色。[ default: #fff ]
								intensity: 1.2, //主光源的强度。[ default: 1 ]
								shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
								shadowQuality: 'high', // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
								alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
								beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
							},
						},

						viewControl: {
							// 用于鼠标的旋转，缩放等视角控制。
							projection: 'orthographic', // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
							autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
							autoRotateDirection: 'cw', // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
							autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
							autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
							damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
							rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
							zoomSensitivity: 1, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
							panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
		
							
							panMouseButton: 'right', // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
							rotateMouseButton: 'left', // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
							orthographicSize: 100,
							distance: 80, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
							minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
							maxDistance: 120, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。

							alpha: 75, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
							beta: 8, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
							minAlpha: 45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
							maxAlpha: 75, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
							minBeta: -90, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
							maxBeta: 90, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]

							center: [0, 10, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
							animation: true, // 是否开启动画。[ default: true ]
							animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
							animationEasingUpdate: 'cubicInOut', // 过渡动画的缓动效果。[ default: cubicInOut ]
						},
						// regions: regions,
					},
					series: [{
							name: "锡林浩特市",
							silent: false,
							// 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
							type: 'scatter3D',
							coordinateSystem: 'geo3D',
						
					
							symbol: "circle",
							symbolSize: [15, 15],
							// 
							// animation: true,
							// animationEasingUpdate: 'cubicOut',
							// animationDurationUpdate: 500,
							itemStyle: {
								color:'#EFAB44',
								
								// color: "transparent",
							},
							
							zlevel: 1000,
							label: {
								show: false,
								// align: 'center',        // 水平居中
								// verticalAlign: 'middle', // 垂直居中
								// distance: 0,
								
								formatter(params) {
									return "";
								},

								// textStyle: {
								// 	color: "transparent",
								// 	padding: [10,10],
								// 	backgroundColor: {
								// 		image: require('@/assets/back/mark.png'),

								// 	},
								// },
							},
							// emphasis: {
							// 	label: {
							// 		show: true,
							// 		position: "left",
							// 		distance: 0,
							// 		formatter(params) {
							// 			return "2";
							// 		},

							// 		textStyle: {
							// 			color: "transparent",
							// 			padding: [30,40],
							// 			backgroundColor: {
							// 				image: require('@/assets/back/mark.png'),

							// 			},
							// 		},
							// 	},

							// },

							data: mapData
						},





					],
					tooltip: {
						show: true, // 显示提示框
						trigger: "item",
						backgroundColor: 'rgba(0,0,0,0.82)',
						formatter: function(params) {
							// 格式化提示框内容，这里使用标记点的信息
							console.log(params)
							return "<div class='tooltip-warp'><div class='tooltip-name'>" + params.data.name +
								"</div>" + "<div class='tooltip-item'>" + '累计贷款笔数/金额：' + params.data.allLoanCount +
								'笔/' + params.data.allLoanAmount + (params.data?.allLoanAmountCheckY == 1 ? '万' :
									params.data?.allLoanAmountCheckY == 2 ? '亿' : '') + "</div>" +
								"<div class='tooltip-item'>" + '执行中贷款笔数/金额：' + params.data.inLoanCount + '笔/' +
								params.data.inLoanAmount  + (params.data?.inLoanAmountCheckY == 1 ? '万' : params.data
									?.inLoanAmountCheckY == 2 ? '亿' : '') + "</div></div>"



						},
					},

				}




				this.$echarts.registerMap('FeatureCollection', this.mapJeoData)
				// 隐藏动画加载效果。
				// chart.hideLoading()
				this.chart.setOption(cahrtOption)
				window.addEventListener("resize", () => {
					this.chart.resize();
				});



				// chart.getZr().on('click', (params) => {
				// 	console.log(_this.currentItem)

				// })



			},
		},
	}
</script>

<style lang="scss">
	#mapMain {
		width: 100%;
		height: 100%;
	}

	.tooltip-warp {

		font-size: 0.15rem;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: rgba(255, 255, 255, 0.9686);

		.tooltip-item {
			display: flex;
			align-items: center;
		}

		.tooltip-item::before {

			content: '';
			/* 必须有 content 属性 */
			display: inline-block;
			width: 0.08rem;
			height: 0.08rem;
			background: #EFAB44;
			border-radius: 50%;
			/* 使其成为圆形 */
			margin-right: 0.13rem;
		}
	}
</style>